import axios from "axios";
import { handleAPIError, handleAPISuccess, removeEmptyFields } from "./utils/utilsAPI";
import { tokenAndIdValidation, createChargerValidation, deleteChargerByIdValidation, chargerIdValidation, addChargerValidation } from "./utils/validateAPI";
import { BASE_URL, getConfig, TEST_URL } from "./constant";
import { ADD_TOAST_MESSAGE } from "../store/dbFilter/actionTypes";
import store from "../store";
import { successToast } from "../store/dbFilter/actions";

const token = "8lQzN922rpRDaMbh3m5J";

const apiCharger = axios.create({
  baseURL: `${BASE_URL}/chargers`,
});

const apiChargerTest = axios.create({
  baseURL: `${TEST_URL}/chargers`,
});


// Used in the ChargerDetails Page, since not getting lastheartbeat in the get
/**
 * validates the argument received and Makes an API call to get all the chargers
 * @param {string} id - id of the charger to get the data
 * @returns {Promise} - Resolves when the promise returns all the chargers or empty array in case of no charger or logs in case of failure.
 */
const getCharger = async (id) => {
  const payload = {
    token: token,
    id: id,
  };
  try {
    await tokenAndIdValidation.validate(payload);
    const res = await apiCharger.get(`/`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};



// **********************************************TEST API*******************************************************
/**
 * validates the argument received and Makes an API call to get all the chargers
 * @param {string} id - id of the charger to get the data
 * @returns {Promise} - Resolves when the promise returns all the chargers or empty array in case of no charger or logs in case of failure.
 */
const getChargerById = async (id) => {
  const payload = {
    chargerId: id,
  };
  try {
    await chargerIdValidation.validate(payload);
    const res = await apiChargerTest.get(`/byId`, { params: payload, ...getConfig() });
    const { data } = handleAPISuccess(res);
    if (data?.length === 0) {
      console.log("Charger not found");
      // store.dispatch(errToast({ title: "Err", message: "Charger not found" }));
    }
    return data;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to create or update the Location
 * @param {object} chargerDetail - contains all the data required to create a location
 * @returns {Promise} - Resolves when the promise returns location details  or logs in case of failure.
 */
const addCharger = async (chargerDetail) => {
  const payload = removeEmptyFields(chargerDetail);
  console.log("chargerDetail", payload);

  try {
    await addChargerValidation.validate(payload);
    const res = await apiChargerTest.post(`/add`, payload, getConfig());
    const { message, data } = handleAPISuccess(res);
    console.log(`${message}`, data);
    store.dispatch(successToast({ title: "Success", message: message }));
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};
export { getCharger,  getChargerById, addCharger };
